/**
 * AuditSessionNotFound Component
 *
 * Displays a not found state when the requested audit session cannot be found.
 */

import { Card, Container, Heading, Section, Text, Button, ButtonType, ButtonSize } from '@soteria/design-system-ve';

import * as styles from '../AuditSessionDetailPage.css';

interface AuditSessionNotFoundProps {
  /** Handler for navigating back */
  onBackClick: () => void;
}

export function AuditSessionNotFound({ onBackClick }: AuditSessionNotFoundProps) {
  return (
    <Container className={styles.container}>
      <Section spacing="large">
        <Card className={styles.errorCard}>
          <Section spacing="medium">
            <Heading level="h2">Session Not Found</Heading>
            <Text>The requested audit session could not be found.</Text>
            <Button buttonSize={ButtonSize.Default} buttonType={ButtonType.Tertiary} label="Back to Sessions" onClick={onBackClick} />
          </Section>
        </Card>
      </Section>
    </Container>
  );
}
